import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { Alert, Stack } from 'react-bootstrap'
import { TextInput } from '@ztechapps/webui.input'
import type { InventoryBySerialNumber } from '@ztechapps/common.contract'
import type { SerialNumberStrategy, SerialNumberInputProps, ValidationResult } from './types'

export const validateBatchSerialNumber = (input: string, maxQuantity: number): ValidationResult => {
  const codes = input
    .split(/[\n,]+/)
    .map((code) => code.trim())
    .filter((code) => !isEmpty(code))

  if (isEmpty(codes)) {
    return { isValid: true, serialNumbers: [] }
  }

  if (codes.length > 1) {
    return {
      isValid: false,
      error: 'Batch serial number: only one value is allowed',
      serialNumbers: [],
    }
  }

  // Create N entries with the same batch serial code
  const batchCode = codes[0]
  const serialNumbers = Array(maxQuantity === -1 ? 1 : maxQuantity)
    .fill(null)
    .map(() => ({ code: batchCode }))

  return { isValid: true, serialNumbers }
}

export const getBatchInitialValue = (serialNumbers: InventoryBySerialNumber[]): string => {
  return !isEmpty(serialNumbers) ? serialNumbers[0].code : ''
}

export const BatchSerialNumberInput = ({ value, onChange, disabled, maxQuantity, error }: SerialNumberInputProps) => {
  const maxQtyDisplay = maxQuantity === -1 ? 'unlimited' : maxQuantity

  return (
    <Stack gap={3}>
      <Alert variant="info" className="mb-0">
        <strong>Batch Serial Number:</strong> Enter one serial number that will be used for all {maxQtyDisplay} units in
        this batch.
      </Alert>

      <TextInput
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Enter batch serial number..."
        disabled={disabled}
      />

      <div className="small text-muted">This serial number will be applied to all {maxQtyDisplay} units.</div>

      {error && <div className="text-danger small">{error}</div>}
    </Stack>
  )
}

export const BatchStrategy: SerialNumberStrategy = {
  validator: validateBatchSerialNumber,
  getInitialValue: getBatchInitialValue,
  InputComponent: BatchSerialNumberInput,
}
